export default "__VITE_ASSET__DUGkFB9i__"